module.exports = __webpack_public_path__ + "static/nokia-logo-875c49b3eb9e558f70ab16de614ab7fa.png";